import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  ImageSizeFieldSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

export enum LogoSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xlarge',
}

export const LogoBarHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

export const LogoBarLogoFieldSchema = ImageFieldSchema.extend({
  name: z.literal('logo'),
  role: z.literal(FieldRole.Logo),
});

export const LogoBarLogoSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('size'),
  role: z.literal(FieldRole.Logo),
});

export const LogoBarFieldGroupFieldSchema = z.discriminatedUnion('name', [
  LogoBarLogoFieldSchema,
  LogoBarLogoSizeFieldSchema,
]);

export type LogoBarHeaderField = z.infer<typeof LogoBarHeaderFieldSchema>;
export type LogoBarLogoField = z.infer<typeof LogoBarFieldGroupFieldSchema>;

export const LogoBarHeaderFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(LogoBarHeaderFieldSchema),
});
export type LogoBarHeaderFieldGroup = z.infer<typeof LogoBarHeaderFieldGroupSchema>;

export const LogoBarLogoFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(LogoBarFieldGroupFieldSchema),
});
export type LogoBarLogoFieldGroup = z.infer<typeof LogoBarLogoFieldGroupSchema>;

export const LogoSizeSchema = z.nativeEnum(LogoSize);

export const LogoBarOptionsSchema = z.object({
  colorScheme: ColorSchemeSchema.optional(),
  headerEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
  logoSize: LogoSizeSchema.optional(),
  layout: z.string().optional(),
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
});

export type LogoBarOptions = z.infer<typeof LogoBarOptionsSchema>;

export const LogoBlockConfigSchema = z.object({
  options: LogoBarOptionsSchema,
  type: z.literal(BlockType.LogoBar),
  fieldGroups: z.tuple([LogoBarHeaderFieldGroupSchema]).rest(LogoBarLogoFieldGroupSchema),
  version: z.literal(1),
});
